import  React from 'react';
import { Alert, Card, Tabs, Layout } from 'antd';
import { Routes } from '../../../routes'; 
import Spinner from '../../components/Spinner/Spinner';
import ILTInstructors from '../../components/ILTInstructors/ILTInstructors';
import ILTAddresses from '../../components/ILTAddresses/ILTAddresses';
import useHasError from '../../hooks/useHasError'; 
import useIsLoading from '../../hooks/useIsLoading'; 
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { flags } from '../../../featureFlags/flags';
import { useFeatureFlags } from '../../../featureFlags';
import './styles.less';

const ILTPage = ( props ) => {
    const [ ILT_ENABLED ] = useFeatureFlags( [ flags.ILT_ENABLED ] );
    const { isLoading } = useIsLoading( { items: [] } );
    const { hasError } = useHasError( { items: [] } );
    
    const breadcrumbs = [
        { name: 'Course Studio', path: Routes.Home.buildPath() },
        { name: 'Learning Content', path: Routes.LearningContentNav.buildPath() },
        { name: 'Instructor Led Training' }
    ];

    const modifiedCallback = ( modified ) => {

    };
 
    /*************************************
     *  ANCHOR Render
     *************************************/
    
    return ( 
        <Layout className="ilt-page">
            
            { /* Page header breadcrumbs */ }
            <Breadcrumbs crumbs={ breadcrumbs }/>

            { ILT_ENABLED &&
                <>
                    { /* Loading Spinner */ }
                    { isLoading &&
                        <Spinner/>
                    }
             
                    { /* Main Content */ }
                    { !isLoading &&
                        <Card
                            className="ilt-content"
                            title="Instructor Led Training"
                        >   
                            { /* Error message */ }
                            { hasError && 
                                <Alert 
                                    type="error"
                                    message="Error"
                                    description="An unknown error occurred. Please try again later."
                                />
                            }

                            { !hasError &&
                                <Tabs 
                                    type="card"
                                    size="large"
                                    items={
                                        [
                                            {
                                                key: 'instructors',
                                                label: 'Instructors',
                                                children: <ILTInstructors
                                                    modifiedCallback={ modifiedCallback }
                                                />
                                            },
                                            {
                                                key: 'addresses',
                                                label: 'Addresses',
                                                children: <ILTAddresses  
                                                    showChooser={ false } 
                                                    modifiedCallback={ modifiedCallback }
                                                />
                                            }
                                        ]
                                    }
                                />
                            }
                        </Card>
                    }
                </>
            }

            { !ILT_ENABLED &&
                <Alert
                    style={ { marginLeft: '24px', marginRight: '24px' } } 
                    type="warning"
                    message="Disabled"
                    description="This feature is disabled for this company."
                />
            }
        </Layout>
    );
};

export default ILTPage;
